import { render, staticRenderFns } from "./input.vue?vue&type=template&id=bf01fe80&"
import script from "./input.vue?vue&type=script&lang=ts&"
export * from "./input.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports